import React from 'react';
import ReactDOM from 'react-dom';

import {ConfigProvider} from "antd";
import enUS from "antd/lib/locale/en_US";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import 'dayjs/locale/zh-cn'

import * as serviceWorker from './serviceWorker';
import './index.css';
import App from './pages/App';
import {store} from "./models";

import {AliveScope} from "react-activation";

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <ConfigProvider locale={enUS}>
                <AliveScope>
                    <App/>
                </AliveScope>
            </ConfigProvider>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
